/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Contact_Admin_PermissionsInputs */



/**
* | output |
* | --- |
* | "Contact your team admin or manager to change permissions." |
*
* @param {Knp_Guide_Contact_Admin_PermissionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_contact_admin_permissions = /** @type {((inputs?: Knp_Guide_Contact_Admin_PermissionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Contact_Admin_PermissionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Contactez l’administrateur ou le manager de votre équipe pour modifier les autorisations.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wenden Sie sich an Ihren Teamadministrator oder Manager, um die Berechtigungen zu ändern.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Contatta l'amministratore o il responsabile del tuo team per modificare le autorizzazioni.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для изменения прав доступа обратитесь к администратору или менеджеру вашей команды.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comuníquese con el administrador o gerente de su equipo para cambiar los permisos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请联系您的团队管理员或经理更改权限。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("権限を変更するには、チーム管理者またはマネージャーに連絡してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुमतियों में बदलाव करने के लिए अपनी टीम के एडमिन या मैनेजर से संपर्क करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Para alterar as permissões, entre em contato com o administrador ou gerente da sua equipe.")
	return /** @type {LocalizedString} */ ("Contact your team admin or manager to change permissions.")
});